import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  useEventPlateId,
  usePlateEditorRef,
} from '@udecode/plate';

import { ToolbarButton } from './ToolbarButton';

export const HistoryButtons = ({ ...props }) => {
  const editor = usePlateEditorRef(useEventPlateId());

  return (
    <>
      <ToolbarButton
        name="Undo"
        icon={<FontAwesomeIcon icon={['fa', 'undo']} />}
        onClick={() => editor.undo()}
        {...props}
      />
      <ToolbarButton
        name="Redo"
        icon={<FontAwesomeIcon icon={['fa', 'redo']} />}
        onClick={() => editor.redo()}
        {...props}
      />
    </>
  );
};
